<template lang="pug">
  base-side-nav(:items='menuItems')
</template>

<script>
import BaseSideNav from "@/shared/components/BaseSideNav";

export default {
  components: { BaseSideNav },
  data() {
    return {
      menuItems: [
        {
          label: "Panels",
          icon: "mobile",
          routeName: "spage:panelList",
          subNav: []
        }
      ]
    };
  }
};
</script>
